import { Injectable, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { contentHeaders, contentXWWWHeaders } from 'common/headers';
import { BaseHttpService } from '../base/_base-http.service';
import { AuthService } from '../auth/auth.service';
import { BrandService } from '../brand/brand.service';
import { SessionService } from '../session/session.service';
import { Config } from '../config/env.config';
import { ListManagerModel } from './list-manager.model';
import { SearchModel } from '../../product-details-v2/components/fitments/fitment-ymm-search/ymm-search.model';
import {catchError} from 'rxjs/operators';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';


@Injectable()
export class ListManagerService extends BaseHttpService {

  API_URL: string = 'data-lists';

  constructor(
    protected http: HttpClient,
    protected authService: AuthService,
    protected brandService: BrandService,
    protected sessionService: SessionService,
    @Inject('LIST_TYPE') protected LIST_TYPE: string,
  ) {
    super(http, authService, brandService, sessionService);
  }

  get brandId(): string {
    return this.brandService.getBrand();
  }

  get fetchUrl(): string {
    return `${this.API_URL}/${this.brandId}/${this.LIST_TYPE}`;
  }

  get createNewListUrl(): string {
    return `${this.API_URL}/${this.brandId}/${this.LIST_TYPE}`;
  }

  fetch(): Observable<any> {
    return this.http.get(`${Config.API}/${this.fetchUrl}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  update(list: any): Observable<any> {
    const body = JSON.stringify({ data: { name: list.name } });
    return this.http.put(
      `${Config.API}/${this.API_URL}/${this.brandId}/${list._id}`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  updateBunch(lists: Array<any>): Observable<any> {
    const requests = _.map(lists, (list: any) => {
      return this.update(list);
    });
    return forkJoin(requests)
        .pipe(catchError(this.handleError.bind(this)));
  }

  remove(id: any): Observable<any> {
    return this.http.delete(
      `${Config.API}/${this.API_URL}/${this.brandId}/${id}`,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  removeBunch(ids: Array<any>): Observable<any> {
    const requests = _.map(ids, (id: any) => {
      return this.remove(id);
    });
    return forkJoin(requests)
        .pipe(catchError(this.handleError.bind(this)));
  }

  createNewList(name: string): Observable<any> {
    const body = JSON.stringify({ data: { name } });
    return this.http.post(
      `${Config.API}/${this.createNewListUrl}`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  addToList(
    ids: Array<any>,
    listId: any,
    filter?: any,
  ): Observable<any> {
    let body: any;
    if (filter) {
      body = JSON.stringify(filter);
    } else {
      body = JSON.stringify({ data: { ids: _.map(ids, (id) => String(id)) } });
    }
    return this.http.post(
      `${Config.API}/${this.API_URL}/${this.brandId}/${listId}/apply`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

  addToLists(
    ids: Array<number|string>,
    selectedLists: Array<ListManagerModel>,
    status?: string,
    state?: string,
    filter?: any,
  ): Observable<any> {
    let body: string;
    const listIds: Array<any> = _.map(selectedLists, '_id');
    body = 'data[listIds]=' + encodeURIComponent(JSON.stringify(listIds));
    if (filter) {
      body += '&state=' + encodeURIComponent(state) +
      '&filter[status]=' + encodeURIComponent(status) +
      '&filter=' + filter;
    } else {
      body += '&data[ids]=' + encodeURIComponent(JSON.stringify(ids));
    }
    return this.http.post(
      `${Config.API}/${this.API_URL}/${this.brandId}/apply`,
      body,
      {headers: contentXWWWHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  addToDataLists(
    ids: Array<number|string>,
    selectedLists: Array<ListManagerModel>,
    status?: any,
    state?: any,
    filter?: any
  ): Observable<any> {
    const listIds: Array<any> = _.map(selectedLists, '_id');

    const bodyIds = JSON.stringify(ids);
    const bodyListIds = JSON.stringify(listIds);

    filter =  filter ? '&' + filter : '';
    status = status ? '&filter[status] =' + status : '';
    state = state ? '&state=' + state : '';

    const body =
      'data[ids]=' + encodeURIComponent(bodyIds) +
      '&data[listIds]=' + encodeURIComponent(bodyListIds) +
      status +
      state +
      filter
      ;

    return this.http.post(
      `${Config.API}/data-lists/${this.brandId}/apply`,
      body,
      {headers: contentXWWWHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  addToListBunch(
    ids: Array<any>,
    selectedLists: Array<ListManagerModel>,
    filter?: any,
  ): Observable<any> {
    const requests = _.map(selectedLists, (item: ListManagerModel) => {
      return this.addToList(ids, item._id, filter);
    });
    return forkJoin(requests)
        .pipe(catchError(this.handleError.bind(this)));
  }

  removeFromList(
    ids: Array<any>,
    listId: any
  ): Observable<any> {
    const body = JSON.stringify({ data: { ids: _.map(ids, (id) => String(id)) } });
    return this.http.post(
      `${Config.API}/${this.API_URL}/${this.brandId}/${listId}/remove`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }
}
